module.exports = __webpack_public_path__ + "static/media/easter2.e016a9e8.png";